import type {
  OptionListParams,
  PriceCalendarParams,
  PopularPlaceType,
  SearchPointToPointTicketParam,
  TicketDetailParams,
} from '~models/Transportation/PointToPointTicket';

const pointToPointTicketKeys = {
  all: ['pointToPointTicket'] as const,
  placeList: (keyword: string, page?: number, size?: number) =>
    [...pointToPointTicketKeys.all, 'placeList', keyword, page, size] as const,
  search: (params: SearchPointToPointTicketParam) =>
    [...pointToPointTicketKeys.all, 'search', params] as const,
  getLegSolutionFirstList: (correlationId: string, outboundOfferId?: string) =>
    [
      ...pointToPointTicketKeys.all,
      'getLegSolutionFirstList',
      correlationId,
      ...(outboundOfferId ? [outboundOfferId] : []),
    ] as const,
  getLegSolutionAllList: (correlationId: string, outboundOfferId?: string) =>
    [
      ...pointToPointTicketKeys.all,
      'getLegSolutionAllList',
      correlationId,
      ...(outboundOfferId ? [outboundOfferId] : []),
    ] as const,
  getOptionList: (params: OptionListParams) =>
    [...pointToPointTicketKeys.all, 'getOptionList', params] as const,
  getTicketDetail: (params: TicketDetailParams) =>
    [
      ...pointToPointTicketKeys.all,
      'getTicketDetail',
      params.correlationId,
      params.outboundOfferId,
      ...(params.inboundOfferId ? [params.inboundOfferId] : []),
    ] as const,
  getBoardingInfo: (trpOrderId: string) =>
    [...pointToPointTicketKeys.all, 'getBoardingInfo', trpOrderId] as const,
  getPriceCalendar: (params: PriceCalendarParams) =>
    [...pointToPointTicketKeys.all, 'getPriceCalendar', ...Object.values(params)] as const,
  getPopularPlaceList: (type: PopularPlaceType) =>
    [...pointToPointTicketKeys.all, 'getPopularPlaceList', type] as const,
  getPopularRouteList: () => [...pointToPointTicketKeys.all, 'getPopularRouteList'] as const,
  transportProducts: () => [...pointToPointTicketKeys.all, 'transportProduct'] as const,
  transportProduct: (gid: number) => [...pointToPointTicketKeys.transportProducts(), gid] as const,
};

export { pointToPointTicketKeys };
